module.exports = __webpack_public_path__ + "static/media/19ESCAP31.f7761abb.jpg";